import Vue from 'vue'
import Router from 'vue-router'
import AboutUs from '@/components/EN-vers/menu/AboutUs'
import News from '@/components/EN-vers/menu/News'
import History from '@/components/EN-vers/menu/History'
import ClubUnion from '@/components/EN-vers/menu/ClubUnion'
import Turism from '@/components/EN-vers/menu/Turism'
import Contact from '@/components/EN-vers/menu/Contact'
import AbautHorses from '@/components/EN-vers/menu/AbautHorses'

Vue.use(Router)

export default new Router({
  routes: [
    {
    path:'/AboutUs',
    name: 'AboutUs',
    component: AboutUs
    },
    {
      path: '/',
      name: 'News',
      component: News
    },
    {
      path: '/History',
      name: 'History',
      component: History
    },
    {
    path:'/ClubUnion',
    name: 'ClubUnion',
    component: ClubUnion
    },
    {
    path:'/turism',
    name: 'Turism',
    component: Turism
    },
    {
    path:'/Contact',
    name: 'Contact',
    component: Contact
    },
    {
    path:'/AbautHorses',
    name: 'AbautHorses',
    component: AbautHorses
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js